export enum ToolType {
  PAN = 'PAN',
  PIPES = 'PIPES',
  SYMBOL = 'SYMBOL',
  CROP = 'CROP'
}

export enum SystemType {
  DRAINAGE = 'DRAINAGE',
  TRADE_WASTE = 'TRADE_WASTE',
  VENT = 'VENT',
  AFFLUENT = 'AFFLUENT'
}

export enum SymbolType {
  // Fixtures
  WC = 'WC',
  BASIN = 'BASIN',
  WASHING_MACHINE = 'WM',
  SINK = 'SINK',
  DISHWASHER = 'DW',
  LAUNDRY_TUB = 'LT',
  BATH = 'BATH',
  FLOOR_WASTE = 'FW',
  SHOWER = 'SHOWER',
  TUNDISH = 'TUNDISH',
  
  // Fittings
  IO = 'IO',
  IOS = 'IOS',
  CO = 'CO',
  COS = 'COS',
  ORG = 'ORG',
  SWIVEL_JOINT = 'SWIVEL',
  EXPANSION_JOINT = 'EXPAN',

  // Directional
  RISER = 'RISER',
  DROPPER = 'DROPPER'
}

export interface Point {
  x: number;
  y: number;
  ux?: number; // Universal X (True World Location)
  uy?: number; // Universal Y (True World Location)
  attachedSymbolId?: string; // Links a pipe node to a fixture
}

export interface Line {
  id: string;
  points: Point[];
  color: string;
  system: SystemType;
}

export interface TradeSymbol {
  id: string;
  type: SymbolType;
  position: Point;
  system: SystemType;
}

export interface MarkupState {
  lines: Line[];
  symbols: TradeSymbol[];
}

export interface ViewSettings {
  dynamicFading: boolean;
  symbolScale: number;
  scaleWithPlan: boolean;
  showGrid: boolean;
  snapToGrid: boolean;
  gridSize: number;
}

export interface Project {
  id: string;
  name: string;
  address?: string;
  siteClassification?: string;
  approvalNo?: string;
  lot?: string;
  rp?: string;
  clientName?: string;
  clientContact?: string;
  notes?: string;
  thumbnail: string;
  lastModified: number;
  markup: MarkupState;
  image: string;
  isLocked?: boolean;
  authorizedAt?: number;
}

export interface PaidProject {
  projectId: string;
  authorizedAt: number;
  source: 'trial' | 'subscription' | 'single';
}